import script from "./GenreSelection16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenreSelection16167.vue?vue&type=script&setup=true&lang=ts"

import "./GenreSelection16167.vue?vue&type=style&index=0&id=7ca8166b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca8166b"]])

export default __exports__